module.exports = __webpack_public_path__ + "static/media/september.6af8fdf6.png";